import React, { Component } from 'react';

import compose from 'recompose/compose';

import PropTypes from 'prop-types';

// Graphql
import { graphql } from 'react-apollo';
import gql from 'graphql-tag';

// React Table
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import matchSorter from 'match-sorter';

// Components Imports
import ProjectDetail from './ProjectDetail';
import CustomLoader from './innerComponents/CustomLoader';

// Material UI Imports
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import Checkbox from '@material-ui/core/Checkbox';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

// Material Icons Imports
import IconContentAdd from '@material-ui/icons/AddCircle';
import IconSaveAlt from '@material-ui/icons/FileCopy';
import PrintIcon from '@material-ui/icons/Print';
import IconBack from '@material-ui/icons/ArrowBack';
import IconEdit from '@material-ui/icons/Edit';
import GetAppIcon from '@material-ui/icons/GetApp';

// Route Imports
import { Link } from 'react-router-dom';

// Lodash
import _ from 'lodash';
import ProjectTableActions from './innerComponents/ProjectTableActions';

// moment
import moment from "moment";

// axios
import axios from "axios";

// Assets imports
import '../styles/ReactTable.css';
import '../styles/ProjectsList.css';

import { Parser } from 'json2csv'

const styles = {
  paperStyle: {
    width: "60%",
    margin: "0 auto",
    height: "auto",
  },
};

// This is a custom filter UI for selecting
// a unique option from a list

function SelectColumnFilter({ filter, onChange }) {
  return (
    <select
      onChange={event => {
        onChange(event.target.value)
        }
      }
      style={{ width: "100%" }}
      value={filter ? filter.value : "all"}
    >
      <option value="all">All projects</option>
      <option value="completed">Completed</option>
      <option value="missing">Missing</option>
      <option value="not_apply">Does not apply</option>
    </select>
  )
}

function SelectStatusColumnFilter({ filter, onChange }) {
  return (
    <select
      onChange={event => {
        onChange(event.target.value)
        }
      }
      style={{ width: "100%" }}
      value={filter ? filter.value : "all"}
    >
      <option value="all">All status</option>
      <option value="live">Live</option>
      <option value="completed">Completed</option>
      <option value="cancelled">Cancelled</option>
    </select>
  )
}

function PdfOperationsStatusFilter({ filter, onChange }) {
  return (
    <select
      onChange={event => onChange(event.target.value)}
      style={{ width: "100%" }}
      value={filter ? filter.value : "0"}
    >
      <option value="0">All</option>
      <option value="1">Started</option>
      <option value="2">Processing</option>
      <option value="3">Finished</option>
    </select>
  )
}

class ProjectsList extends Component {
  state = {
    refetch: false,
    refetchDetail: false,
  }

  constructor(props) {
    super(props);
    this.state = {
      value: props.match.params.tab ? props.match.params.tab : 0,
      showList: true,
      showDetail: false,
      selectedId: "1",
      selectedName: null,
      refetch: false,
      refetchDetail: false,
      exportToCSVProjectsButton: true,
      projectFilters: [],
      archivedProjectFilters: [],
      downloadingPdf: false,
      filter_by: "All",
    };
  }

  _handleBackClick() {
    this.setState({
      showList: !this.state.showList,
      showDetail: !this.state.showDetail,
      refetchDetail: false
    });
  }

  handleClick(info) {
    try {
      this.setState({
        selectedId: info.row.id,
        selectedName: info.row.name,
        showList: !this.state.showList,
        showDetail: !this.state.showDetail
      });
    }
    catch (e) {

    }
  }

  handleArchive() {
    this.props.all_projects_query.refetch()
      .then(this.props.all_inactive_projects_query.refetch())
      .then(this.setState({
        refetchDetail: true
      }));
  }

  componentDidMount() {
    if (this.props.location.state && this.props.location.state.refetchDetail === true) {
      this.setState({refetchDetail: true})
    }
  }

  componentWillMount() {
    if (this.props.location.state && this.props.location.state.refetch === true) {
      this.props.all_projects_query.refetch().then(()=> {
        this.props.location.state.refetch = false
        this.setState({
          refetchDetail: true
        })
      })
    }
    else if (this.props.location.state === undefined) {
      console.log("no location")
      this.props.location.state = {
        refetch: false
      }
    }
  }

  handleTabChange = (event, value) => {
    this.setState({value});
  }

  handleOnStatuFilterChange = (filter, row) => {
    if(filter.value === '0')
        return true;

    if(filter.value === '1')
        return row[filter.id] === 'Started';

    if(filter.value === '2')
        return row[filter.id] === 'Processing';

    if(filter.value === '3')
        return row[filter.id] === 'Finished';
  }

  handleDownloadReport = (pdfOperation) => {
    var apiBaseUrl = process.env.REACT_APP_BACKEND_BASE_URL + `/reports/send_project_pdf_report/${pdfOperation.id}`;
    axios.get(
      apiBaseUrl,
      {
        responseType: 'arraybuffer',
        headers: {
          'Authorization': localStorage.getItem("token")
        }
    }).then((response)=>{
        const url = window.URL.createObjectURL(new Blob([response.data],
          { type: 'application/pdf' }));
        const link = document.createElement('a');
        link.href = url;
        const linkDownload = document.createElement('a');
        linkDownload.href = url;
        linkDownload.setAttribute('download', pdfOperation.baseFileName);
        document.body.appendChild(linkDownload);
        linkDownload.click();
        this.setState({downloadingPdf: false});
    }).catch((error) => {
        this.setState({downloadingPdf: false});
        console.log(error);
        alert('Error downloading Project Pdf Report');
    });
  }

  handleExportToCSV(table) {
    const date = moment(new Date()).format('YYYY_MM_DD-HH_mm_a')
    let tableReference;
    let report_name;
    switch (table) {
        case 'projects':
            tableReference = this.projectsReactTable;
            report_name = `rhodar_projects_report-${date}`
            break;
        default:
            return;
    }

    let tableData = tableReference.getResolvedState().sortedData.map(data => {
        return _.omitBy(data, (value, key) => {
            return _.startsWith(key, '_')
        });
    }).map(data => {
        if (this.state.projectFilters === null ) {
            if (data.startDate) {
                const closestExpiringCerticateDate = moment(data.startDate).format('YYYY-MM-DD')
                data.startDate = closestExpiringCerticateDate
            }
        } else {
            data.id = parseInt(data.id);
        }
        return data;
    })

    if (tableData[0]) {
        const fields = Object.keys(tableData[0]).filter(key => key != "actions");
        const json2csvParser = new Parser({ fields });
        const csv = json2csvParser.parse(tableData);
        const url = window.URL.createObjectURL(new Blob([csv],
            { type: 'text/csv' }));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${report_name}.csv`);
        document.body.appendChild(link);
        link.click()
    }
  }

  render() {


    const role = localStorage.getItem('current_user_role')
    const { classes } = this.props;

    // Check if the query response is being loaded
    if (this.props.all_projects_query && this.props.all_projects_query.loading) {
      return <CustomLoader label={'Loading'}/>
    }

    if (this.props.all_inactive_projects_query && this.props.all_inactive_projects_query.loading) {
      return <CustomLoader label={'Loading'}/>
    }

    // Check if there were errrors
    if (this.props.all_projects_query && this.props.all_projects_query.error) {
      return <div>Error</div>
    }

    if (this.props.all_inactive_projects_query && this.props.all_inactive_projects_query.error) {
      return <div>Error</div>
    }

    // Check if the query response is being loaded
    if (this.props.all_pdf_operations_query && this.props.all_pdf_operations_query.loading) {
      return <CustomLoader label={'Loading'}/>
    }

    // Check if there were errrors
    if (this.props.all_pdf_operations_query && this.props.all_pdf_operations_query.error) {
      return <div>Error</div>
    }

    const projects_id_int = this.props.all_projects_query.projects.map(project => {
      project.id = parseInt(project.id, 10)
      return project
    })

    const inactive_projects_id_int = (this.props.all_inactive_projects_query.projects || []).map(project => {
      project.id = parseInt(project.id, 10)
      return project
    })

    const all_projects = _.orderBy(projects_id_int, 'startDate', 'desc');

    const all_inactive_projects = _.orderBy(inactive_projects_id_int, 'startDate', 'desc');

    const pdf_operations = this.props.all_pdf_operations_query.pdfOperations ? this.props.all_pdf_operations_query.pdfOperations.map(pdfOperation => {
      pdfOperation.id = parseInt(pdfOperation.id);
      if(pdfOperation.project){
        pdfOperation.project.id = parseInt(pdfOperation.project.id);
      }
      return pdfOperation;
    }).filter((row) => row.id) : [];

    const all_pdf_operations = _.orderBy(pdf_operations, 'startDate', 'desc');

    const columns = [
      {
        Header: 'Id',
        accessor: 'id',
        filterable: false,
        maxWidth: 100
      },
      {
        Header: 'Number',
        id: "number",
        accessor: d => d.number,
        filterMethod: (filter, rows) =>
          matchSorter(rows, filter.value, { keys: ["number"] }),
        filterAll: true
      },
      {
        Header: 'Name',
        accessor: 'name',
        filterMethod: (filter, rows) =>
          matchSorter(rows, filter.value, { keys: ["name"] }),
        filterAll: true
      },
      {
        Header: 'Start Date',
        id: 'startDate',
        accessor: d => d.startDate,
        filterMethod: (filter, rows) =>
          matchSorter(rows, filter.value, { keys: [item => moment(item.startDate).format('YYYY-MM-DD')] }),
        filterAll: true,
        Cell: c => (<span>{moment(c.original.startDate).format('YYYY-MM-DD')}</span>)
      },
      {
        Header: 'End Date',
        id: 'endDate',
        accessor: d => d.endDate,
        filterMethod: (filter, rows) =>
          matchSorter(rows, filter.value, { keys: [item => moment(item.endDate).format('YYYY-MM-DD')] }),
        filterAll: true,
        Cell: c => (<span>{moment(c.original.endDate).format('YYYY-MM-DD')}</span>)
      },
      {
        Header: 'Mandatory Questions',
        id: "mandatory",
        accessor: d => {
          return d.dailyEntriesStatus
        },
        filterMethod: (filter, row) => {
          if (filter.value === "all") {
            // this.setState({filter_by: "all"});
            return true;
          }
          if (filter.value === "completed") {
            // this.setState({filter_by: "Completed"});
            return row[filter.id] === "Completed";
          }
          if (filter.value === "missing") {
            // this.setState({filter_by: "Missing"});
            return row[filter.id] === "Missing";
          }
          if (filter.value === "not_apply") {
            // this.setState({filter_by: "Not apply"});
            return row[filter.id] === "Not apply";
          }
        },
        Filter: SelectColumnFilter,
      },
      {
        Header: 'Status',
        id: "status",
        accessor: d => {
          return d.status
        },
        filterMethod: (filter, row) => {
          if (filter.value === "all") {
            return true;
          }
          if (filter.value === "live") {
            return row[filter.id] === "Live";
          }
          if (filter.value === "completed") {
            return row[filter.id] === "Completed";
          }
          if (filter.value === "cancelled") {
            return row[filter.id] === "Cancelled";
          }
        },
        Filter: SelectStatusColumnFilter,
      }
    ]

    if (role === 'Admin' || role === 'Office') {
      columns.push({
        id: "actions",
        Header: 'Actions',
        filterable: false,
        sortable: false,
        Cell: c => <div className={classes.cell}><ProjectTableActions handler={this.handleArchive.bind(this)} project={c.original} /></div>
      })
    }

    const pdfOperationColumns = [
      {
        Header: 'Id',
        id: "jobId",
        accessor: d => d.id,
        filterable: false,
      },
      {
        Header: 'Number',
        id: "number",
        accessor: d => d.project ? d.project.number : '',
        filterMethod: (filter, rows) =>
          matchSorter(rows, filter.value, { keys: ["number"] }),
        filterAll: true
      },
      {
        Header: 'Name',
        id: "name",
        accessor: d => d.project ? d.project.name : '',
        filterMethod: (filter, rows) =>
          matchSorter(rows, filter.value, { keys: ["name"] }),
        filterAll: true
      },
      {
        Header: 'Start Date',
        id: "startDate",
        accessor: d => d.startDate,
        filterMethod: (filter, rows) =>
          matchSorter(rows, filter.value, { keys: ["startDate"] }),
        filterAll: true,
        Cell: c => (<span>{moment(c.original.startDate).format('YYYY-MM-DD HH:mm:ss')}</span>)
      },
      {
        Header: 'End Date',
        id: "endDate",
        accessor: d => d.endDate,
        filterMethod: (filter, rows) =>
          matchSorter(rows, filter.value, { keys: ["endDate"] }),
        filterAll: true,
        Cell: c => (<span>{moment(c.original.endDate).format('YYYY-MM-DD HH:mm:ss')}</span>)
      },
      {
        Header: 'Status',
        id: "status",
        accessor: d => d.status,
        filterMethod: (filter, row) => { return this.handleOnStatuFilterChange(filter, row)},
        Filter: PdfOperationsStatusFilter,
      },
      {
        Header: 'Actions',
        id: 'actions',
        filterable: false,
        sortable: false,
        Cell: c => {
          return (
            <div className={classes.cell}>
              <Button
                disabled={c.original.status !== 'Finished'}
                onClick={() => {
                    this.setState({downloadingPdf: true});
                    this.handleDownloadReport(c.original);
                  }}>
                  <GetAppIcon/>
              </Button>
            </div>
          );
        }
      }
    ]

    let projectListNode;
    if (this.state.showList) {
      projectListNode =
        <div>
          <AppBar position='static'>
              <Tabs value={this.state.value} onChange={this.handleTabChange} fullWidth>
                  <Tab label="live projects" />
                  <Tab label="pdf operations" />
                  {(role === 'Admin' || role === 'Office') && (
                    <Tab label="Archived Projects" />
                  )}
              </Tabs>
          </AppBar>
          {this.state.value === 0 &&
          <div>
              <div className="ProjectsList-header">
                <div className="ProjectsList-title">
                  <span>Projects List</span>
                </div>
                <div className="ProjectsList-actions">
                  <Button
                    component={Link}
                    to="/projects/new"
                    color="primary"
                  ><IconContentAdd style={{ marginRight: 8 }} /> New Project </Button>
                  <Button
                      color="primary"
                      disabled={this.state.exportToCSVProjectsButton}
                      onClick={() => this.handleExportToCSV('projects')}
                  ><IconSaveAlt className={classes.iconButton} />Export to CSV {this.state.filter_by}</Button>
                </div>
              </div>
              <div className="ProjectsList-table">
                <ReactTable
                  data={all_projects}
                  ref={(r) => this.projectsReactTable = r}
                  filterable
                  // defaultFilterMethod={(filter, row) =>
                  //   String(row[filter.id]) === filter.value}
                  columns={columns}
                  onFetchData={(state, instance) => {
                    this.setState({ exportToCSVProjectsButton: (state.sortedData.length <= 0) });
                  }}
                  defaultPageSize={10}
                  className="-striped -highlight"
                  getTdProps={(state, rowInfo, column, instance) => {
                    const info = rowInfo;
                    return {
                      onClick: e => {
                        if (column.Header !== 'Actions'){
                          this.handleClick(info);
                        }
                      }
                    };
                  }}
                  filtered={this.state.projectFilters}
                  onFilteredChange={filtered => {
                    this.setState({
                      filter_by: filtered.map(item => {
                        return (item.value === 'all') ? '' : (" - " + item.id + ": " + item.value)
                      })
                    });
                    this.setState({projectFilters: filtered})
                  }}
                  />
              </div>
          </div>}
          {this.state.value === 1 &&
            <div>
              <div className="ProjectsList-header">
                <div className="ProjectsList-title">
                  <span>Pdf Operations List</span>
                </div>
              </div>
                { this.state.downloadingPdf &&
                  <div>
                    <CustomLoader label={'Downloading Project Pdf Report'} spinnerType ={'ScaleLoader'}/>
                  </div>
                }
              <div className="ProjectsList-table">
                <ReactTable
                  data={all_pdf_operations}
                  filterable
                  columns={pdfOperationColumns}
                  defaultPageSize={10}
                  className="-striped -highlight"
                  />
              </div>
            </div>
          }
          {this.state.value === 2 && (
            <div>
              <div className="ProjectsList-header">
                <div className="ProjectsList-title">
                  <span>Archived Project List</span>
                </div>
                <div className="ProjectsList-actions">

                </div>
              </div>
              <div className="ProjectsList-table">
                <ReactTable
                  data={all_inactive_projects}
                  filterable
                  columns={columns}
                  defaultPageSize={10}
                  className="-striped -highlight"
                  getTdProps={(state, rowInfo, column, instance) => {
                    const info = rowInfo;
                    return {
                      onClick: e => {
                        if (column.Header !== 'Actions') {
                          this.handleClick(info);
                        }
                      }
                    };
                  }}
                  filtered={this.state.archivedProjectFilters}
                  onFilteredChange={filtered => this.setState({archivedProjectFilters: filtered})}
                  />
              </div>
            </div>
          )}
        </div>
    }

    let projectDetailNode;
    if (this.state.showDetail) {
      projectDetailNode =
        <div>
          <div className="ProjectsList-detailFooter">
            <Button variant="contained"
              color="primary"
              onClick={this._handleBackClick.bind(this)}
            ><IconBack style={{ marginRight: 8 }} /> Back</Button>
          </div>
          <div className="ProjectsList-header">
            <div className="ProjectsList-title">
              <span>{this.state.selectedName}</span>
            </div>
            <div className="ProjectsList-actions">
              <Button size="small"
                component={Link}
                color="primary"
                to={`/projects/${this.state.selectedId}/edit`}
              >
                <IconEdit style={{ marginRight: 8 }} /> Edit</Button>
              <Button size="small"
                component={Link}
                color="primary"
                to={`/projects/${this.state.selectedId}/print`}
              >
                <PrintIcon style={{ marginRight: 8 }} /> Site Packs</Button>
            </div>
          </div>
          <div className="ProjectsList-detailContent">
            <ProjectDetail selectedId={this.state.selectedId} refetch={this.state.refetchDetail} />
          </div>
          <div className="ProjectsList-detailFooter">
            <Button variant="contained"
              color="primary"
              onClick={this._handleBackClick.bind(this)}
            ><IconBack style={{ marginRight: 8 }} /> Back</Button>
          </div>
        </div>;
    }

    return (
      <Paper className={classes.paperStyle} elevation={1} >
        <div>
          {projectListNode}
          {projectDetailNode}
        </div>
      </Paper>
    );
  }
}

ProjectsList.propTypes = {
  classes: PropTypes.object.isRequired,
};

const ALL_PROJECTS_QUERY = gql`
  query {
    projects(filters:[{field:"mark_as_deleted_eq", operand:"false"}]) {
      id
      number
      name
      mark_as_deleted
      startDate
      endDate
      dailyEntriesStatus
      status
    }
  }
`;

const ALL_PDF_OPERATIONS = gql`
  query {
    pdfOperations {
      id
      jobId
      startDate
      endDate
      status
      baseFileName
      project {
        id
        number
        name
      }
    }
  }
`;

const ALL_INACTIVE_PROJECTS_QUERY = gql`
query {
  projects(filters:[{field:"mark_as_deleted_eq", operand:"true"}]) {
    id
    number
    name
    mark_as_deleted
    startDate
    endDate
    dailyEntriesStatus
    status
  }
}
`;

// Exporting the query
export default compose(
  graphql(ALL_PROJECTS_QUERY, { name: 'all_projects_query' }),
  graphql(ALL_PDF_OPERATIONS, { name: 'all_pdf_operations_query' }),
  graphql(ALL_INACTIVE_PROJECTS_QUERY, { name: 'all_inactive_projects_query' }),
  withStyles(styles)
)(ProjectsList);



// WEBPACK FOOTER //
// src/components/ProjectsList.js